import * as React from "react";
import { IconPresentationProps } from "@insite/mobius/Icon/Icon";

const FaceBook: React.FC<IconPresentationProps> = props => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="59" height="58" viewBox="0 0 59 58">
            <g id="FB" transform="translate(-9495.309 -6042.478)">
                <g
                    id="Area_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_"
                    data-name="Area [SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]"
                    transform="translate(9495.309 6042.478)"
                    fill="none"
                    stroke="#fff"
                    stroke-width="2"
                >
                    <rect width="59" height="58" rx="29" stroke="none" />
                    <rect x="1" y="1" width="57" height="56" rx="28" fill="none" />
                </g>
                <g
                    id="Icon_ICON_feather_facebook_SIZE_MEDIUM_STATE_DEFAULT_STYLE_STYLE2_"
                    data-name="Icon [ICON=feather/facebook][SIZE=MEDIUM][STATE=DEFAULT][STYLE=STYLE2]"
                    transform="translate(9512.196 6059.195)"
                >
                    <rect
                        id="Area_ICON:feather_facebook_SIZE:MEDIUM_STATE:DEFAULT_STYLE:STYLE2_"
                        data-name="Area [ICON:feather/facebook][SIZE:MEDIUM][STATE:DEFAULT][STYLE:STYLE2]"
                        width="24"
                        height="24"
                        transform="translate(0.112 0.282)"
                        fill="rgba(253,73,198,0.35)"
                        opacity="0"
                    />
                    <g id="Icon" transform="translate(5.527)">
                        <path
                            id="ddb6a75b-60f3-4bef-9ba3-c1d6af8fbb1b"
                            d="M20.51,2H16.826a6.142,6.142,0,0,0-6.141,6.141v3.685H7v4.913h3.685v9.826H15.6V16.739h3.685l1.228-4.913H15.6V8.141a1.229,1.229,0,0,1,1.228-1.228H20.51Z"
                            transform="translate(-7 -2)"
                            fill="none"
                            stroke="#fff"
                            stroke-linecap="round"
                            stroke-linejoin="round"
                            stroke-width="2"
                        />
                    </g>
                </g>
            </g>
        </svg>
    );
};

export default React.memo(FaceBook);
